import { createPinia } from 'pinia';
import { createApp } from 'vue';
import PrimeVue from 'primevue/config';
import Tooltip from 'primevue/tooltip';
import { createHead } from '@vueuse/head';
import 'primevue/resources/themes/aura-light-green/theme.css';
import App from './App.vue';
import router from './router';
import store from './store';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap';
import './assets/styles/reset.css';

const pinia = createPinia();
const app = createApp(App);
const head = createHead();

app.use(head);
app.use(pinia);
app.use(PrimeVue);
app.directive('tooltip', Tooltip);
app.use(store).use(router).mount('#app');
